import { connect } from 'react-redux';

import { offerSelector } from '../../selectors';
import { businessShoppingCenterSelector } from '../../selectors/offerData/offer/businessShoppingCenterSelector';
import { IState } from '../../store';
import { AdditionalFeaturesCommercial, IAdditionalFeaturesCommercialProps } from './AdditionalFeaturesCommercial';
import { AdditionalFeatures, IAdditionalFeaturesProps } from './index';

export function mapStateToProps(state: IState): IAdditionalFeaturesProps {
  return {
    businessShoppingCenter: businessShoppingCenterSelector(state),
    offer: offerSelector(state),
  };
}

export const AdditionalFeaturesContainer = connect<IAdditionalFeaturesProps, {}, {}>(mapStateToProps)(
  AdditionalFeatures,
);

export const AdditionalFeaturesCommercialContainer = connect<IAdditionalFeaturesCommercialProps, {}, {}, IState>(
  state => ({
    businessShoppingCenter: businessShoppingCenterSelector(state),
    offer: offerSelector(state),
  }),
  {},
)(AdditionalFeaturesCommercial);
